import Glider from "../../../js/glider";

require("../../../js/glider");

const KEY_CODES = {
    ENTER: 13,
    SPACE: 32,
    TAB: 9,
};

const HeroCarousel = {
  init: function (element) {
    this.gliderElement = element.querySelector(".glider");
    this.element = element;

    const slideCount = element.querySelectorAll(".hero-carousel-card").length;
    const autoplayEnabled = element.classList.contains('autoplay')

    this.configureMediaControls.bind(this)();

    if (slideCount === 1) {
      element.classList.add("no-carousel");
      return;
    }

    this.duration = element.attributes['data-autoplay-duration'] ? element.attributes['data-autoplay-duration'].value * 1000 : 0;
    this.addCtasListeners();

    this.gliderElement.addEventListener('glider-slide-visible', this.updateControlsAndGliderPos.bind(this));
    this.gliderElement.addEventListener('glider-animated', this.updateControlsAndGliderPos.bind(this));

    if (autoplayEnabled === true) {
        if (this.duration > 0) {
          this.gliderElement.addEventListener('glider-loaded', () => {
            this.gliderElement.setAttribute('data-current-slide', 0);
            this.interval = this.startGlideAutoSlide();
            this.buttons.pauseBtn.classList.add('active');
            this.buttons.playBtn.classList.remove('active');
          })
        }
    }

    this.glider = new Glider(this.gliderElement, {
      slidesToShow: 1,
      slidesToScroll: 1,
      scrollLock: true,
      draggable: false,
    });

  },

  updateControlsAndGliderPos: function (evt) {
    const currPage = evt?.detail?.value || evt?.detail?.slide;
    if (!isNaN(currPage) && +currPage !== +this.gliderElement.dataset.currentSlide) {
        const controlBtn = this.element.querySelector(`.hero-carousel__bottom-controls button:nth-child(${currPage + 1})`);
        if (controlBtn) {
            const btnss = this.element.querySelectorAll('.hero-carousel__bottom-controls button');
            Array.from(btnss)
                .forEach(btn => btn?.classList.remove("active"));
            controlBtn?.classList.add("active");
            this.gliderElement.dataset.currentSlide = currPage;
        }
    }
  },

  configureMediaControls: function () {
    const arrMediaWrapper = this.element.querySelectorAll('.hero-carousel-card__bg-media--video');
    for (const element of arrMediaWrapper) {

        const playButton = element.querySelector('.hero-carousel__button-play');
        const pauseButton = element.querySelector('.hero-carousel__button-pause');
        const controlsWrapper = element.querySelector('.hero-carousel__video-controls');
        const video = element.querySelector('iframe');

        if (playButton && playButton.addEventListener) {
          playButton.addEventListener('click', () => {
            this.videoToggle(video, 'play');
            controlsWrapper.classList.add('playing');
          })
        }

        if (pauseButton && pauseButton.addEventListener) {
          pauseButton.addEventListener('click', () => {
            this.videoToggle(video, 'pause');
            controlsWrapper.classList.remove('playing');
          })
        }

      }
  },

  videoToggle: function (video, action) {
    const data = { method: action };
    const url = video.src.split('?')[0];

    if (url !== undefined) {
      video.contentWindow.postMessage(JSON.stringify(data), url);
    }
  },

  onKeyDownCtaControl: function (evt) {
    if (evt.target && +evt.target.dataset.heroCarouselPosition !== 0) {
        return;
    }
    if (evt.keyCode === KEY_CODES.TAB && evt.shiftKey) {
        evt.preventDefault();
        this.focusActiveCard();
    }
  },

  addCtasListeners: function () {
    for (const el of this.element.querySelectorAll(
      ".hero-carousel__bottom-controls button"
    )) {
      if (el && el.addEventListener) {
        el.addEventListener("click", this.onClickSlideButton.bind(this));
        el.addEventListener("keydown", this.onKeyDownCtaControl.bind(this));
      }
    }

    const playBtn = this.element.querySelector('.hero-carousel__top-controls .play');
    const pauseBtn = this.element.querySelector('.hero-carousel__top-controls .pause');

    if (playBtn && playBtn.addEventListener) {
      playBtn.addEventListener('click', this.onPlayGlider.bind(this));
      playBtn.addEventListener("keydown", this.onKeyDownPlayGlider.bind(this));
    }

    if (pauseBtn && pauseBtn.addEventListener) {
      pauseBtn.addEventListener('click', this.onPauseGlider.bind(this));
      pauseBtn.addEventListener('keydown', this.onKeyDownPauseGlider.bind(this));
    }

    this.buttons = {
        playBtn,
        pauseBtn
    }
  },

  onKeyDownPlayGlider: function (evt) {
    if (evt.keyCode === KEY_CODES.ENTER || evt.keyCode === KEY_CODES.SPACE) {
        evt.preventDefault();
        this.onPlayGlider(evt);
        const pauseBtn = this.element.querySelector('.hero-carousel__top-controls .pause');
        pauseBtn.focus();
    } else if (evt.keyCode === KEY_CODES.TAB && !evt.shiftKey) {
        evt.preventDefault();
        this.focusActiveCard();
    }
  },

  onKeyDownPauseGlider: function (evt) {
    if (evt.keyCode === KEY_CODES.ENTER || evt.keyCode === KEY_CODES.SPACE) {
        evt.preventDefault();
        this.onPauseGlider(evt);
        const playBtn = this.element.querySelector('.hero-carousel__top-controls .play');
        playBtn.focus();
    } else if (evt.keyCode === KEY_CODES.TAB && !evt.shiftKey) {
        evt.preventDefault();
        this.focusActiveCard();
    }
  },

  focusActiveCard: function () {
    const activeCta = document.querySelector('.hero-carousel-card.glider-slide.active .hero-carousel-card__info-cta .button');
    if (activeCta) {
        activeCta.focus({ focusVisible: true, scroll: false });
    }
  },

  startGlideAutoSlide: function () {
    return setInterval(() => {
        let nextSlide = this.glider.slide + 1;
        if (this.glider.slides[this.glider.slides.length - 1].classList.contains('visible')) {
            nextSlide = 0
          }
        this.glider.scrollItem(nextSlide);
        this.resetActiveControlCtas();
        const nextBtn = this.element.querySelectorAll('.hero-carousel__bottom-controls button')[nextSlide];
        if (nextBtn) {
            nextBtn.classList.add('active');
        }
    }, this.duration);
  },

  onPlayGlider: function (evt) {
    this.buttons.playBtn.classList.remove('active');
    this.buttons.pauseBtn.classList.add('active');
    this.interval = this.startGlideAutoSlide();
  },

  onPauseGlider: function (evt) {
    this.buttons.pauseBtn.classList.remove('active');
    this.buttons.playBtn.classList.add('active');
    if (this.interval) {
        clearInterval(this.interval);
    }
  },

  onClickSlideButton: function (evt) {
    this.resetActiveControlCtas();
    const carouselPos = evt.target.dataset.heroCarouselPosition;

    let nextGliderSlide = !isNaN(carouselPos) ? +carouselPos : 0;
    evt?.target?.classList.add("active");

    this.glider.scrollItem(nextGliderSlide);
    this.gliderElement.setAttribute("data-current-slide", nextGliderSlide);
    this.onPauseGlider();
  },

  resetActiveControlCtas: function () {
    for (const el of this.element.querySelectorAll(
        ".hero-carousel__bottom-controls button"
      )) {
        el.classList.remove("active");
      }
  }
};

export default HeroCarousel;
